import { useEffect } from 'react';
import { SITE_CONFIG } from '../config/site';

const DEFAULT_DESCRIPTION =
  'DiscoXDiscos: catálogo curado de discos con escucha, consulta directa por WhatsApp y academia de DJ.';

const setMetaTag = (selector, attributes) => {
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    Object.entries(attributes.identity).forEach(([key, value]) => {
      tag.setAttribute(key, value);
    });
    document.head.appendChild(tag);
  }

  Object.entries(attributes.values).forEach(([key, value]) => {
    tag.setAttribute(key, value);
  });
};

const removeTag = (selector) => {
  const tag = document.head.querySelector(selector);
  if (tag) tag.remove();
};

const setCanonical = (url) => {
  let link = document.head.querySelector('link[rel="canonical"]');

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }

  link.setAttribute('href', url);
};

const setStructuredData = (structuredData) => {
  const scriptId = 'page-structured-data';
  let script = document.getElementById(scriptId);

  if (!structuredData) {
    if (script) script.remove();
    return;
  }

  if (!script) {
    script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(structuredData);
};

function Seo({
  title = SITE_CONFIG.siteName,
  description = DEFAULT_DESCRIPTION,
  image = '',
  path = '/',
  type = 'website',
  structuredData = null,
  noIndex = false,
}) {
  useEffect(() => {
    const siteUrl = (process.env.REACT_APP_PUBLIC_SITE_URL || window.location.origin)
      .replace(/\/$/, '');
    const canonicalUrl = `${siteUrl}${path.startsWith('/') ? path : `/${path}`}`;
    const fullTitle = title.includes(SITE_CONFIG.siteName)
      ? title
      : `${title} | ${SITE_CONFIG.siteName}`;

    document.title = fullTitle;
    setCanonical(canonicalUrl);

    setMetaTag('meta[name="description"]', {
      identity: { name: 'description' },
      values: { content: description },
    });
    setMetaTag('meta[name="robots"]', {
      identity: { name: 'robots' },
      values: { content: noIndex ? 'noindex,nofollow' : 'index,follow' },
    });
    setMetaTag('meta[property="og:title"]', {
      identity: { property: 'og:title' },
      values: { content: fullTitle },
    });
    setMetaTag('meta[property="og:description"]', {
      identity: { property: 'og:description' },
      values: { content: description },
    });
    setMetaTag('meta[property="og:type"]', {
      identity: { property: 'og:type' },
      values: { content: type },
    });
    setMetaTag('meta[property="og:url"]', {
      identity: { property: 'og:url' },
      values: { content: canonicalUrl },
    });
    setMetaTag('meta[name="twitter:card"]', {
      identity: { name: 'twitter:card' },
      values: { content: image ? 'summary_large_image' : 'summary' },
    });

    if (image) {
      setMetaTag('meta[property="og:image"]', {
        identity: { property: 'og:image' },
        values: { content: image },
      });
      setMetaTag('meta[name="twitter:image"]', {
        identity: { name: 'twitter:image' },
        values: { content: image },
      });
    } else {
      removeTag('meta[property="og:image"]');
      removeTag('meta[name="twitter:image"]');
    }

    setStructuredData(structuredData);
  }, [description, image, noIndex, path, structuredData, title, type]);

  return null;
}

export default Seo;
